import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { setStyleProperty as _$setStyleProperty } from "solid-js/web";
import { className as _$className } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div style=position:absolute>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class=solid-drawer-backdrop><div class=solid-drawer>`),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class=solid-lightbox><img alt>`),
  _tmpl$4 = /*#__PURE__*/_$template(`<button type=button class=solid-btn>`),
  _tmpl$5 = /*#__PURE__*/_$template(`<button type=button>`),
  _tmpl$6 = /*#__PURE__*/_$template(`<div class=solid-modal-backdrop><div class=solid-modal><header></header><div class=solid-modal-body></div><footer>`),
  _tmpl$7 = /*#__PURE__*/_$template(`<button type=button class="solid-btn primary">`);
/**
 * Generic Solid components every module can use. Structural styles live in
 * mmodSolidModule.scss (scoped under `.mmod`, themed via CSS variables with fallbacks —
 * a module's own palette wins when it defines the variables on its root).
 */

import { Show } from 'solid-js';
import { Portal } from 'solid-js/web';
import { useMosy, useLang } from './mmodSolidModule';

/**
 * Positions the module content into the window area computed by msysWM.
 * Pass `class` for the module's design scope (e.g. "mmod-tzr" carrying the CSS variables).
 */
export function ModuleRoot(props) {
  const {
    store
  } = useMosy();
  return (() => {
    var _el$ = _tmpl$();
    _$insert(_el$, () => props.children);
    _$effect(_p$ => {
      var _v$ = `solid-module ${props.class || ''}`,
        _v$2 = `${store.window.x}px`,
        _v$3 = `${store.window.y}px`,
        _v$4 = `${store.window.width}px`,
        _v$5 = `${store.window.height}px`,
        _v$6 = store.window.z,
        _v$7 = store.window.visible ? 'flex' : 'none';
      _v$ !== _p$.e && _$className(_el$, _p$.e = _v$);
      _v$2 !== _p$.t && _$setStyleProperty(_el$, "left", _p$.t = _v$2);
      _v$3 !== _p$.a && _$setStyleProperty(_el$, "top", _p$.a = _v$3);
      _v$4 !== _p$.o && _$setStyleProperty(_el$, "width", _p$.o = _v$4);
      _v$5 !== _p$.i && _$setStyleProperty(_el$, "height", _p$.i = _v$5);
      _v$6 !== _p$.n && _$setStyleProperty(_el$, "z-index", _p$.n = _v$6);
      _v$7 !== _p$.s && _$setStyleProperty(_el$, "display", _p$.s = _v$7);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined,
      i: undefined,
      n: undefined,
      s: undefined
    });
    return _el$;
  })();
}

/**
 * Right slide-in drawer overlay (half screen). Backdrop click closes; content clicks don't.
 * `open` mounts it; the slide-in runs via the solid-drawer CSS animation.
 */
export function Drawer(props) {
  const {
    module
  } = useMosy();
  // portal to the module's positioned root: a drawer opened from inside a positioned
  // ancestor (toolbar button, popover) must still span the whole module, not its parent's box
  const mount = () => {
    var _module$el;
    return ((_module$el = module.el) === null || _module$el === void 0 ? void 0 : _module$el.querySelector('.solid-module')) || module.el;
  };
  return _$createComponent(Show, {
    get when() {
      return props.open;
    },
    get children() {
      return _$createComponent(Portal, {
        get mount() {
          return mount();
        },
        get children() {
          var _el$2 = _tmpl$2(),
            _el$3 = _el$2.firstChild;
          _el$2.$$click = () => {
            var _props$onClose;
            return (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
          };
          _el$3.$$click = e => e.stopPropagation();
          _$insert(_el$3, () => props.children);
          return _el$2;
        }
      });
    }
  });
}

/** Full-screen enlarged image preview; `src` mounts it, click closes. */
export function Lightbox(props) {
  return _$createComponent(Show, {
    get when() {
      return props.src;
    },
    get children() {
      var _el$4 = _tmpl$3(),
        _el$5 = _el$4.firstChild;
      _el$4.$$click = () => {
        var _props$onClose2;
        return (_props$onClose2 = props.onClose) === null || _props$onClose2 === void 0 ? void 0 : _props$onClose2.call(props);
      };
      _$effect(() => _$setAttribute(_el$5, "src", props.src));
      return _el$4;
    }
  });
}

/**
 * Store-driven modal host: renders `store.modal` ({ title, text, kind: 'confirm'|'alert',
 * danger }) and reports the outcome through module.closeModal(result). Mount once in the
 * module view; open via module.confirmModal()/module.alertModal().
 */
export function ModalHost() {
  const {
    store,
    module: m
  } = useMosy();
  const {
    t
  } = useLang();
  const modal = () => store.modal;
  return _$createComponent(Show, {
    get when() {
      return modal();
    },
    get children() {
      var _el$6 = _tmpl$6(),
        _el$7 = _el$6.firstChild,
        _el$8 = _el$7.firstChild,
        _el$9 = _el$8.nextSibling,
        _el$0 = _el$9.nextSibling;
      _el$6.$$click = () => m.closeModal(false);
      _el$7.$$click = e => e.stopPropagation();
      _$insert(_el$8, () => modal().title);
      _$insert(_el$9, () => modal().text);
      _$insert(_el$0, _$createComponent(Show, {
        get when() {
          return modal().kind === 'confirm';
        },
        get fallback() {
          return (() => {
            var _el$11 = _tmpl$7();
            _el$11.$$click = () => m.closeModal(true);
            _$insert(_el$11, () => t('form.ok'));
            return _el$11;
          })();
        },
        get children() {
          return [(() => {
            var _el$1 = _tmpl$4();
            _el$1.$$click = () => m.closeModal(false);
            _$insert(_el$1, () => t('form.cancel'));
            return _el$1;
          })(), (() => {
            var _el$10 = _tmpl$5();
            _el$10.$$click = () => m.closeModal(true);
            _$insert(_el$10, () => t('form.yes'));
            _$effect(() => _$className(_el$10, `solid-btn ${modal().danger ? 'danger' : 'primary'}`));
            return _el$10;
          })()];
        }
      }));
      return _el$6;
    }
  });
}
_$delegateEvents(["click"]);